require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-ball-state-financial-contracts-dei-for-branch-renovations.json") })
        }
      }, "path---articles-ball-state-financial-contracts-dei-for-branch-renovations");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-ball-state-financial-contracts-dei-for-branch-renovations!./.cache/json/articles-ball-state-financial-contracts-dei-for-branch-renovations.json
// module id = 1558
// module chunks = 231608221292675